import(/* webpackMode: "eager", webpackExports: ["IS_SAFARI","IS_IOS","IS_APPLE_WEBKIT"] */ "/tmp/build_625ec67b/node_modules/@payloadcms/richtext-lexical/dist/lexical/utils/environment.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_625ec67b/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_625ec67b/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_625ec67b/src/ui/homepage/BrandSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_625ec67b/src/ui/homepage/CategoriesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_625ec67b/src/ui/homepage/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_625ec67b/src/ui/product/List.tsx");
